// extracted by mini-css-extract-plugin
module.exports = {"BooksOutlineButton":"BooksOutlineButton_BooksOutlineButton__tZO3X","isSmall":"BooksOutlineButton_isSmall__77pPD"};